import wait from '@mailobj-browser/front/js/utils/wait.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import { post } from './ajax.js'

const states = new Map()

export default meta => {
  const { content, ownerDocument } = meta
  const { defaultView } = ownerDocument
  const { FormData } = defaultView
  const [seconds, url] = content.split(';')
  const delay = seconds * 1000
 
  queueMicrotask(async () => {
    while (true) {
      await wait(delay)
      const body = new FormData()
      
      for (const [element, value] of states) {
        const { dataset } = element
        const { refreshUuid: uuid } = dataset
        
        body.set(uuid, value)
      }
      
      if (Array.from(body).length) {
        await post(url, body, {
          enqueue: false,
          target: meta
        })
      }
    }
  })
}

export const set = (
  element,
  { dataset: { refreshState: state } } = element
) => {
  if (!states.has(element)) {
    queueMicrotask(async () => {
      await removed(element)
      states.delete(element)
    })
  }
  
  states.set(element, state)
}
